module.exports = __webpack_public_path__ + "c4252a42661db6d619d6cf0b62e2b911.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-13.png
// module id = 3308
// module chunks = 0